import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F9F9F8]">
      <header className="bg-white border-b border-[#E4E4E7]">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-2xl font-bold tracking-tight">Política de Privacidade</h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-8">
        <div className="bg-white border border-[#E4E4E7] rounded-lg p-8 space-y-6">
          <p className="text-sm text-gray-500">Última atualização: 30 de março de 2026</p>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">1. Dados que Coletamos</h2>
            <p className="text-gray-600 leading-relaxed">Ao usar o Quero Publicar, coletamos:</p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li><strong>Dados do Google:</strong> Nome, email e foto de perfil (fornecidos no login).</li>
              <li><strong>Dados acadêmicos:</strong> Instituição, titulação, áreas de interesse (informados por você).</li>
              <li><strong>Dados de uso:</strong> Chamadas favoritadas, lembretes configurados, sugestões enviadas.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">2. Como Usamos seus Dados</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Personalizar as chamadas exibidas com base nas suas áreas de interesse.</li>
              <li>Enviar lembretes de prazos por email (quando ativado).</li>
              <li>Enviar alertas semanais de novas chamadas (quando ativado).</li>
              <li>Melhorar a plataforma com base em estatísticas de uso.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">3. O que NÃO Fazemos</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Não vendemos seus dados para terceiros.</li>
              <li>Não compartilhamos seu email com revistas ou editoras.</li>
              <li>Não enviamos spam ou emails não solicitados.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">4. Armazenamento e Segurança</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Seus dados são armazenados em servidores seguros.</li>
              <li>Usamos criptografia para proteger informações sensíveis.</li>
              <li>O login é feito via Google OAuth, sem armazenar sua senha.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">5. Cookies e Rastreamento</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Usamos cookies para manter você logado.</li>
              <li>Google AdSense pode usar cookies para exibir anúncios relevantes.</li>
              <li>Não usamos rastreadores de terceiros além do AdSense.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">6. Seus Direitos</h2>
            <p className="text-gray-600 leading-relaxed">Você pode a qualquer momento:</p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li><strong>Acessar:</strong> Ver todos os dados que temos sobre você.</li>
              <li><strong>Corrigir:</strong> Atualizar suas informações no perfil.</li>
              <li><strong>Excluir:</strong> Solicitar a exclusão da sua conta e dados.</li>
              <li><strong>Cancelar:</strong> Desativar alertas e lembretes por email.</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-2">
              Para exercer esses direitos, entre em contato pelo email abaixo.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">7. Menores de Idade</h2>
            <p className="text-gray-600 leading-relaxed">
              O Quero Publicar é destinado a pesquisadores e acadêmicos. 
              Não coletamos intencionalmente dados de menores de 18 anos.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">8. Alterações nesta Política</h2>
            <p className="text-gray-600 leading-relaxed">
              Podemos atualizar esta política periodicamente. Alterações significativas 
              serão comunicadas por email ou aviso na plataforma.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">9. Contato</h2>
            <p className="text-gray-600 leading-relaxed">
              Dúvidas sobre privacidade? Entre em contato: <a href="mailto:quero.publicar@queropublicar.org" className="text-blue-600 hover:underline">quero.publicar@queropublicar.org</a>
            </p>
          </section>

          <div className="pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 text-center">
              Esta política está em conformidade com a Lei Geral de Proteção de Dados (LGPD).
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPage;
